import { endOfDay, startOfDay, subDays } from 'date-fns';
import React, { createContext, useContext, useState, ReactNode, useMemo } from 'react';

type DateSelectionContextType = {
  fromDate: Date;
  toDate: Date;
  setFromDate: (fromDate: Date) => void;
  setToDate: (toDate: Date) => void;
};

const DateSelectionContext = createContext<DateSelectionContextType | undefined>(undefined);

type DateSelectionProviderProps = {
  children: ReactNode;
};

export const DateSelectionProvider: React.FC<DateSelectionProviderProps> = ({
  children,
}: DateSelectionProviderProps) => {
  const [fromDate, setFromDate] = useState<Date>(subDays(new Date(), 1));
  const [toDate, setToDate] = useState<Date>(new Date());

  const fromDateSoD = useMemo(() => {
    return startOfDay(fromDate);
  }, [fromDate]);

  const toDateEoD = useMemo(() => {
    return endOfDay(toDate);
  }, [toDate]);

  return (
    <DateSelectionContext.Provider
      value={{ fromDate: fromDateSoD, toDate: toDateEoD, setFromDate, setToDate }}
    >
      {children}
    </DateSelectionContext.Provider>
  );
};

export const useDateSelection = (): DateSelectionContextType => {
  const context = useContext(DateSelectionContext);
  if (context === undefined) {
    throw new Error('useDateSelection must be used within a DateSelectionProvider');
  }
  return context;
};
